module.exports = __webpack_public_path__ + "static/img/joy.f813e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/joy.png
// module id = N35t
// module chunks = 0